export default __webpack_public_path__ + "static/media/logo.3a3f927b.png";